import React, { useState, useEffect } from "react";
import User from "../../assets/User.png";
import { DataView, DataViewLayoutOptions } from "primereact/dataview";
import { Paginator } from "primereact/paginator";
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { Checkbox } from "primereact/checkbox";
import { Tag } from "primereact/tag";
import { InputText } from "primereact/inputtext";
import { getUsersBySchoolRole } from "../../apis/Users";
import { useSchoolStore } from "../../store/SchoolStore";

const UserList = ({ usersChange, setUsersChange, submitted, editUser, confirmDeleteUser, roleId }) => {

  const [first, setFirst] = useState(null);
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState(2);
  const [totalRecord, setTotalRecord] = useState(0);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [layout, setLayout] = useState("grid");
  const [users, setUsers] = useState([]);

  const [{ schoolId }] = useSchoolStore();

  useEffect(() => {

    async function fetchData() {
      const u = await getUsersBySchoolRole({
        schoolRoleId: roleId,
        page: page + 1,
        size: rows,
        search: globalFilter,
        schoolId: schoolId,
      });

      if (
        u &&
        u.data &&
        u.data.data &&
        u.data.data.data &&
        Array.isArray(u.data.data.data)
      ) {
        setUsers(u.data.data.data);
        setTotalRecord(u.data.data.totalRecord);
      }
    }

    fetchData();

    setFirst(page);
    setFirst(first);
    setRows(rows);

  }, [roleId, submitted, usersChange, page, first, rows, globalFilter, schoolId]);

  const onSelectUsersChange = (e) => {
    let _data = [...usersChange];
    if (e.checked) _data.push(e.value);
    else _data.splice(_data.indexOf(e.value), 1);
    setUsersChange(_data);
    console.log(usersChange);
  };

  const onPageChange = (event) => {
    setPage(event.page);
    setFirst(event.first);
    setRows(event.rows);
  };

  const header = () => (
    <div className="flex flex-wrap gap-2 align-items-center justify-content-between">
      <h4 className="m-0">Manage Users</h4>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
        />
      </span>
      <DataViewLayoutOptions
        layout={layout}
        onChange={(e) => setLayout(e.value)}
      />
    </div>
  );

  const listItemLoader = (data) => {
    return (
      <div className="col-12">
        <div className="flex flex-column xl:flex-row xl:align-items-start p-4 gap-4">
          <Skeleton className="w-9 sm:w-16rem xl:w-10rem shadow-2 h-6rem block xl:block mx-auto border-round" />
          <div className="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-4">
            <div className="flex flex-column align-items-center sm:align-items-start gap-3">
              <Skeleton className="w-8rem border-round h-2rem" />
              <Skeleton className="w-6rem border-round h-1rem" />
              <div className="flex align-items-center gap-3">
                <Skeleton className="w-6rem border-round h-1rem" />
                <Skeleton className="w-3rem border-round h-1rem" />
              </div>
            </div>
            <div className="flex sm:flex-column align-items-center sm:align-items-end gap-3 sm:gap-2">
              <Skeleton className="w-4rem border-round h-2rem" />
              <Skeleton shape="circle" className="w-3rem h-3rem" />
            </div>
          </div>
        </div>
      </div>
    );
  };

  const gridItemLoader = (data) => {
    return (
      <div className="col-12 sm:col-6 lg:col-12 xl:col-4 p-2">
        <div className="p-4 border-1 surface-border surface-card border-round">
          <div className="flex flex-wrap align-items-center justify-content-between gap-2">
            <Skeleton className="w-6rem border-round h-1rem" />
            <Skeleton className="w-3rem border-round h-1rem" />
          </div>
          <div className="flex flex-column align-items-center gap-3 py-5">
            <Skeleton className="w-9 shadow-2 border-round h-10rem" />
            <Skeleton className="w-8rem border-round h-2rem" />
            <Skeleton className="w-6rem border-round h-1rem" />
          </div>
          <div className="flex align-items-center justify-content-between">
            <Skeleton className="w-4rem border-round h-2rem" />
            <Skeleton shape="circle" className="w-3rem h-3rem" />
          </div>
        </div>
      </div>
    );
  };

  const displayRole = (name) => {
    return <span className="font-semibold">{name}</span>;
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          rounded
          outlined
          onClick={() => editUser(rowData)}
        />
        <Button
          icon="pi pi-trash"
          rounded
          outlined
          severity="danger"
          onClick={() => confirmDeleteUser(rowData)}
        />
      </React.Fragment>
    );
  };

  const getStatus = (user) => {
    switch (user.status) {
      case "ONLINE":
        return "success";

      case "BUSY":
        return "danger";

      default:
        return "warning";
    }
  };

  const listItem = (user) => {
    return (
      <div className="col-12">
        <div className="flex flex-column xl:flex-row xl:align-items-start p-4 gap-4">
          <img
            className="w-9 sm:w-16rem xl:w-10rem shadow-2 block xl:block mx-auto border-round"
            src={user.image ? user.image : User}
            alt={user.firstName + " " + user.lastName}
          />
          <div className="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-4">
            <div className="flex flex-column align-items-center sm:align-items-start gap-3">
              <Checkbox
                inputId={user.id}
                name="id"
                value={user.id}
                onChange={onSelectUsersChange}
                checked={usersChange.includes(user.id)}
              />
              <div className="text-2xl font-bold text-900">
                {user.firstName + " " + user.lastName}{" "}
                <i
                  className="pi pi-verified"
                  color={"green"}
                  style={{ color: "green" }}
                ></i>
              </div>
              <span>
                <i className="pi pi-tag mr-2"></i>
                {user.staffId}
              </span>
              <span>
                <i className="pi pi-envelope mr-2"></i>
                {user.email}
              </span>
              <span>
                <i className="pi pi-phone mr-2"></i>
                {user.phone}
              </span>
              <span>
                <i className="pi pi-map-marker mr-2"></i> {user.location}
              </span>
              <div className="flex align-items-center gap-3">
                <span className="flex align-items-center gap-2">
                  <i className="pi pi-tags"></i>
                  {user.role &&
                  Array.isArray(user.role) &&
                  user.role.length > 0 ? (
                    user.role.map((p) => displayRole(p.name))
                  ) : (
                    <></>
                  )}
                </span>
                <Tag value={user.status} severity={getStatus(user)}></Tag>
              </div>
            </div>
            <div className="flex sm:flex-column align-items-center sm:align-items-end gap-3 sm:gap-2">
              {actionBodyTemplate(user)}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const gridItem = (user) => {
    return (
      <div className="col-12 sm:col-6 lg:col-12 xl:col-4 p-2">
        <div className="p-4 border-1 surface-border surface-card border-round">
          <div className="flex flex-wrap align-items-center justify-content-between gap-2">
            <div className="flex align-items-center gap-2">
              <i className="pi pi-tags"></i>
              {user.role &&
              Array.isArray(user.role) &&
              user.role.length > 0 ? (
                user.role.map((p) => displayRole(p.name))
              ) : (
                <></>
              )}
            </div>
            <Tag value={user.status} severity={getStatus(user)}></Tag>
          </div>
          <div className="flex flex-column align-items-center gap-3 py-5">
            <img
              className="w-9 shadow-2 border-round"
              src={user.image ? user.image : User}
              alt={user.firstName + " " + user.lastName}
            />
            <div className="text-2xl font-bold">
              <Checkbox
                className="m-3"
                inputId={user.id}
                name="id"
                value={user.id}
                onChange={onSelectUsersChange}
                checked={usersChange.includes(user.id)}
              />
              {user.firstName + " " + user.lastName}
              <i
                className="pi pi-verified m-3"
                color={"green"}
                style={{ color: "green" }}
              ></i>
            </div>
            <span>
              <i className="pi pi-tag mr-2"></i>
              {user.staffId}
            </span>
            <span>
              <i className="pi pi-envelope mr-2"></i>
              {user.email}
            </span>
            <span>
              <i className="pi pi-phone mr-2"></i>
              {user.phone}
            </span>
            <span>
              <i className="pi pi-map-marker mr-2"></i> {user.location}
            </span>
          </div>
          <div className="flex align-items-center gap-3 sm:gap-2">
            {actionBodyTemplate(user)}
          </div>
        </div>
      </div>
    );
  };

  const itemTemplate = (data, layout) => {
    if (!data) {
      if (layout === "list") return listItemLoader(data);
      else if (layout === "grid") return gridItemLoader(data);
    }
    if (layout === "list") return listItem(data);
    else if (layout === "grid") return gridItem(data);
  };

  return (
    <>
      <DataView
        value={users}
        itemTemplate={itemTemplate}
        layout={layout}
        header={header()}
        dataKey="id"
      />

      <div className="card">
        <Paginator
          first={first}
          page={page}
          rows={rows}
          totalRecords={totalRecord}
          alwaysShow={false}
          onPageChange={(e) => onPageChange(e)}
        />
      </div>
    </>
  );
};

export default UserList;
